import React, { Fragment } from "react";
import { Col, FormGroup, Label, Row } from "reactstrap";
import Dropzone from "react-dropzone-uploader";

const UploadProjectFileClass = ({ onVideoUpload }) => {
  const getUploadParams = ({ meta }) => {
    return {
      url: "https://httpbin.org/post",
    };
  };

  const handleChangeStatus = ({ meta, file, xhr }, status) => {
    if (status === "done") {
      const response = JSON.parse(xhr.response);
      const videoUrl = response.files[0].url;
      onVideoUpload(videoUrl);
    }
  };

  return (
    <Fragment>
      <Row>
        <Col>
          <FormGroup>
            <Dropzone
              accept="video/*"
              className="dropzone dz-clickable"
              getUploadParams={getUploadParams}
              onChangeStatus={handleChangeStatus}
              maxFiles={1}
              multiple={false}
              canCancel={false}
              inputContent="Drop a Video File"
              styles={{
                dropzone: { width: "100%", height: 150 },
                dropzoneActive: { borderColor: "green" },
              }}
            />
          </FormGroup>
        </Col>
      </Row>
    </Fragment>
  );
};

export default UploadProjectFileClass;
  
// import React, { Fragment } from "react";
// import { Col, FormGroup, Label, Row } from "reactstrap";
// import Dropzone from "react-dropzone-uploader";

// const UploadProjectFileClass = () => {
//   const getUploadParams = ({ meta }) => {
//     return {
//       url: "https://httpbin.org/post",
//     };
//   };

//   const handleChangeStatus = ({ meta, file }, status) => {
//     console.log(status, meta, file);
//   };

//   return (
//     <Fragment>
//       <Row>
//         <Col>
//           <FormGroup>
//             <Dropzone
//               accept="video/*"
//               className="dropzone dz-clickable"
//               getUploadParams={getUploadParams}
//               onChangeStatus={handleChangeStatus}
//               maxFiles={10}
//               multiple={false}
//               canCancel={false}
//               inputContent="Drop a Video File"
//               styles={{
//                 dropzone: { width: "100%", height: 150 },
//                 dropzoneActive: { borderColor: "green" },
//               }}
//             />
//           </FormGroup>
//         </Col>
//       </Row>
//     </Fragment>
//   );
// };

// export default UploadProjectFileClass;

// import React, { Fragment } from "react";
// import { Col, FormGroup, Label, Row } from "reactstrap";
// import { UploadProjectFile } from "../../../Constant";
// import Dropzone from "react-dropzone-uploader";

// const UploadProjectFileClass = () => {
//   const getUploadParams = ({ meta }) => {
//     return {
//       url: "https://httpbin.org/post",
//     };
//   };

//   const handleChangeStatus = ({ meta, file }, status) => {};

//   return (
//     <Fragment>
//       <Row>
//         <Col>
//           <FormGroup>
//             <Dropzone
//               className="dropzone dz-clickable"
//               getUploadParams={getUploadParams}
//               onChangeStatus={handleChangeStatus}
//               maxFiles={10}
//               multiple={false}
//               canCancel={false}
//               inputContent="Drop A File"
//               styles={{
//                 dropzone: { width: "100%", height: 150 },
//                 dropzoneActive: { borderColor: "green" },
//               }}
//             />
//           </FormGroup>
//         </Col>
//       </Row>
//     </Fragment>
//   );
// };

// export default UploadProjectFileClass;
